import { isObservable, BehaviorSubject } from 'rxjs';
import { useState, useRef, useDebugValue } from 'react';
import { getEmptySubject } from '../helpers';
export function useObservableStateInternal(useSubscription, state$OrInit, initialState) {
    // Even though hooks are under conditional block
    // it is for a completely different use case
    // which unlikely coexists with the other one.
    // A warning is also added to the docs.
    if (isObservable(state$OrInit)) {
        var state$_1 = state$OrInit;
        var _a = useState(function () {
            if (state$_1 instanceof BehaviorSubject ||
                state$_1.value !== undefined) {
                return state$_1.value;
            }
            if (typeof initialState === 'function') {
                return initialState();
            }
            return initialState;
        }), state = _a[0], setState = _a[1];
        useSubscription(state$_1, setState);
        useDebugValue(state);
        return state;
    }
    else {
        var init_1 = state$OrInit;
        var _b = useState(initialState), state_1 = _b[0], setState = _b[1];
        var input$_1 = useState(getEmptySubject)[0];
        var state$ = useState(function () { return init_1(input$_1, state_1); })[0];
        var callback = useRef(function (state) { return input$_1.next(state); }).current;
        useSubscription(state$, setState);
        useDebugValue(state_1);
        return [state_1, callback];
    }
}
//# sourceMappingURL=use-observable-state-internal.js.map